import React, { useState, useEffect } from "react";
import { Box, Typography, Paper } from "@mui/material";
import axios from "axios";
import { API_BASE_URL } from "../../apiConfig";
import { refreshTokenIfNeeded } from "./refreshTokenIfNeeded";
import { useNavigate } from "react-router-dom";

function Dashboard() {
  const [isLoading, setIsLoading] = useState(true);
  const [article, setArticleCount] = useState(0);
  const [countSotr, setCountStore] = useState(0);
  const [coupon, setCouponCount] = useState(0);
  const [user, setUserCount] = useState(0);
  const navigate = useNavigate();
  const [storesChartData, setStoresChartData] = useState([]);

  const [storesChartWithCouponsData, setStoresChartWithCouponsData] = useState(
    [],
  );

  const fetchDataCarCount = async () => {
    //const token = localStorage.getItem("token");
    //const refresh = localStorage.getItem("refresh");

    const token = localStorage.getItem("token");
    if (!token) {
      return navigate("/", { replace: true });
    }
    setIsLoading(true);
    try {
      const response = await axios.get(`${API_BASE_URL}SiteInfo/GetAllInfo`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      setArticleCount(response.data.allArticle);
      setCountStore(response.data.allStore);
      setCouponCount(response.data.allcoupon);
      setUserCount(response.data.allUsers);

      const top5StoresChart = response.data.stores
        .sort((a, b) => b.visitCount - a.visitCount)
        // .slice(0, 5)
        .map((store) => ({
          label: store.slug,
          value: store.visitCount,
        }));

      setStoresChartData(top5StoresChart);

      const colors = ["#ffcc00", "#ff6666", "#3399ff", "#66cc66", "#9966FF"];
      const top5StoresChartWithCoupons = response.data.storesWithGroupCoupons
        .sort((a, b) => b.total - a.total)
        .slice(0, 5)
        .map((store, index) => ({
          label: store.slug,
          value: store.total,
          color: colors[index % colors.length],
        }));

      setStoresChartWithCouponsData(top5StoresChartWithCoupons);

      // حذف الفاصلة الأخيرة
      setIsLoading(false);
    } catch (error) {
      if (error.response && error.response.status === 401) {
        const newToken = await refreshTokenIfNeeded();

        if (!newToken) {
          return navigate("/", { replace: true });
        }

        try {
          const retryResponse = await axios.get(
            `${API_BASE_URL}SiteInfo/GetAllInfo`,
            {
              headers: { Authorization: `Bearer ${newToken}` },
            },
          );

          setArticleCount(retryResponse.data.allArticle);
          setCountStore(retryResponse.data.allStore);
          setCouponCount(retryResponse.data.allcoupon);
          setUserCount(retryResponse.data.allUsers);

          const top5StoresChart = retryResponse.data.stores
            .sort((a, b) => b.visitCount - a.visitCount)
            // .slice(0, 5)
            .map((store) => ({
              label: store.slug,
              value: store.visitCount,
            }));

          setStoresChartData(top5StoresChart);

          const colors = [
            "#ffcc00",
            "#ff6666",
            "#3399ff",
            "#66cc66",
            "#9966FF",
          ];
          const top5StoresChartWithCoupons =
            retryResponse.data.storesWithGroupCoupons
              .sort((a, b) => b.total - a.total)
              .slice(0, 5)
              .map((store, index) => ({
                label: store.slug,
                value: store.total,
                color: colors[index % colors.length],
              }));

          setStoresChartWithCouponsData(top5StoresChartWithCoupons);
          setIsLoading(false);
          // استخدم البيانات بعد التحديث
        } catch (retryError) {
          // console.error("Retry failed:", retryError);
          // return <navigate to="/" />;
        }
      } else {
        alert("Error:", error);
      }

      setIsLoading(false);
      // alert("Error fetching data:", error);
    }
  };

  const fetchDataCustomerCount = async () => {
    const token = localStorage.getItem("token");

    if (!token) {
      navigate("/", { replace: true });
    }
  };

  useEffect(() => {
    fetchDataCarCount();
    fetchDataCustomerCount();
  }, []);

  const stats = {
    totalCars: { label: "عدد المتاجر ", value: countSotr },
    rentedCars: { label: "عدد الكوبونات", value: coupon },
    totalRevenue: { label: "عدد المقالات", value: article },
    totalClients: { label: "عدد المشرفين", value: user },
  };

  if (isLoading) {
    return (
      <div
        style={{
          background: "#272727",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "90vh",
        }}
      >
        <div
          style={{
            width: "40px",
            height: "40px",
            border: "4px solid #999",
            borderTop: "4px solid white",
            borderRadius: "50%",
            animation: "spin 1s linear infinite",
          }}
        ></div>

        <style>
          {`
            @keyframes spin {
              0% { transform: rotate(0deg); }
              100% { transform: rotate(360deg); }
            }
          `}
        </style>
      </div>
    );
  }

  return (
    <div
      dir="rtl"
      style={{
        color: "white",
        maxWidth: "100%",
        maxHeight: "100%",
        fontFamily: "'Changa', sans-serif",
      }}
    >
      <h3>لوحة تحكم المشرف - الإحصائيات</h3>

      <Box
        sx={{
          display: "flex",
          justifyContent: "space-around",
          flexWrap: "wrap",
          gap: "20px",
          marginBottom: "40px",
          marginTop: "6%",
        }}
      >
        {Object.values(stats).map(({ label, value }, index) => (
          <Paper
            key={index}
            sx={{
              width: "200px",
              height: "100px",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              backgroundColor: "#333",
              color: "white",
              borderRadius: "10px",
              padding: "10px",
            }}
          >
            <Typography style={{ fontSize: "100%" }}>{label}</Typography>
            <Typography variant="h5" style={{ fontWeight: "bold" }}>
              {value}
            </Typography>
          </Paper>
        ))}
      </Box>
      <hr style={{ borderTop: "1px solid #333" }} />

      <Box
        sx={{
          width: "100%",
          height: "55vh",
          display: "flex",
          justifyContent: "center",
          marginTop: "1%",
          borderRadius: "10px",

          gap: 22,
          flexWrap: "wrap",
        }}
      >
        <div style={{ textAlign: "center", margin: "40px 0" }}>
          <h3 style={{ color: "#e6e6e6", fontSize: "18px" }}>
            نسبة الكوبونات في أعلى 5 متاجر
          </h3>

          {storesChartWithCouponsData.length > 0 &&
            (() => {
              const total = storesChartWithCouponsData.reduce(
                (sum, item) => sum + item.value,
                0,
              );

              const gradientString = storesChartWithCouponsData
                .reduce((acc, item, index) => {
                  const start = storesChartWithCouponsData
                    .slice(0, index)
                    .reduce((sum, curr) => sum + curr.value, 0);
                  const end = start + item.value;

                  const startPercent = (start / total) * 100;
                  const endPercent = (end / total) * 100;

                  return `${acc}${item.color} ${startPercent}% ${endPercent}%, `;
                }, "")
                .slice(0, -2);

              return (
                <div
                  style={{
                    width: "280px",
                    height: "280px",
                    borderRadius: "50%",
                    background: `conic-gradient(${gradientString})`,
                    margin: "0 auto",
                    position: "relative",
                  }}
                >
                  <div
                    style={{
                      position: "absolute",
                      top: "25%",
                      left: "25%",
                      width: "140px",
                      height: "140px",
                      backgroundColor: "#272727",
                      borderRadius: "50%",
                    }}
                  ></div>
                </div>
              );
            })()}

          <div
            style={{
              marginTop: "10px",
              color: "#f3f3f3",
              fontSize: "14px",
            }}
          >
            {storesChartWithCouponsData.map((item, index) => {
              const total = storesChartWithCouponsData.reduce(
                (sum, s) => sum + s.value,
                0,
              );
              const percent = ((item.value / total) * 100).toFixed(1);
              return (
                <div
                  key={index}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "1px",
                    marginBottom: "1px",
                  }}
                >
                  <span
                    style={{
                      display: "inline-block",
                      width: "12px",
                      height: "12px",
                      backgroundColor: item.color,
                      borderRadius: "3px",
                    }}
                  ></span>
                  <span style={{ flex: 1 }}>{item.label}</span>
                  <span style={{ fontWeight: "bold" }}>{percent}%</span>
                </div>
              );
            })}
          </div>
        </div>

        <div style={{ textAlign: "center", margin: "40px 0" }}>
          <h3 style={{ color: "#e6e6e6", fontSize: "18px" }}>
            عدد زيارات أعلى 5 متاجر
          </h3>

          <div
            style={{
              display: "flex",
              alignItems: "flex-end",
              justifyContent: "center",
              height: "300px",
              gap: "25px",
              marginTop: "70px",
              flexWrap: "wrap",
            }}
          >
            {storesChartData.map((item, idx) => {
              const maxValue =
                Math.max(...storesChartData.map((s) => Math.sqrt(s.value))) ||
                1;
              const maxHeight = 350;
              const barHeight = (Math.sqrt(item.value) / maxValue) * maxHeight;

              return (
                <div
                  key={idx}
                  style={{
                    width: "120px",
                    height: `${barHeight}px`,
                    backgroundColor: "#4dd0e1",
                    position: "relative",
                    borderRadius: "6px",
                    transition: "height 0.3s ease-in-out",
                  }}
                >
                  <span
                    style={{
                      position: "absolute",
                      top: "-25px",
                      left: "50%",
                      transform: "translateX(-50%)",
                      fontSize: "15px",
                      color: "white",
                      fontWeight: "bold",
                    }}
                  >
                    {item.value}
                  </span>
                  <div
                    style={{
                      position: "absolute",
                      bottom: "-22px",
                      left: "50%",
                      transform: "translateX(-50%)",
                      fontSize: "14px",
                      color: "white",
                      fontWeight: "500",
                      whiteSpace: "nowrap",
                      textAlign: "center",
                    }}
                  >
                    {item.label}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </Box>
    </div>
  );
}

export default Dashboard;

// import React, { useState, useEffect } from "react";
// import { Box, Typography, Paper } from "@mui/material";
// import axios from "axios";
// import { API_BASE_URL } from "../../apiConfig";

// function Dashboard() {
//   const [article, setArticleCount] = useState(0);
//   const [store, setStoreCount] = useState(0);
//   const [coupon, setCouponCount] = useState(0);
//   const [user, setUserCount] = useState(0);

//   const fetchDataCarCount = async () => {
//     const token = localStorage.getItem("token");

//     if (!token) {
//       throw new Error("Token not available. Please log in.");
//     }

//     try {
//       const response = await axios.get(`${API_BASE_URL}SiteInfo/GetAllInfo`, {
//         headers: {
//           Authorization: `Bearer ${token}`,
//         },
//       });
//       setArticleCount(response.data.allArticle);
//       setStoreCount(response.data.allStore);
//       setCouponCount(response.data.allcoupon);
//       setUserCount(response.data.allUsers);
//     } catch (error) {
//       console.error("Error fetching data:", error);
//     }
//   };

//   const fetchDataCustomerCount = async () => {
//     const token = localStorage.getItem("token");

//     if (!token) {
//       throw new Error("Token not available. Please log in.");
//     }
//   };

//   useEffect(() => {
//     fetchDataCarCount();
//     fetchDataCustomerCount();
//   }, []);

//   const stats = {
//     totalCars: { label: "عدد المتاجر ", value: store },
//     rentedCars: { label: "عدد الكوبونات", value: coupon },
//     totalRevenue: { label: "عدد المقالات", value: article },
//     totalClients: { label: "عدد المشرفين", value: user },
//   };

//   return (
//     <div
//       dir="rtl"
//       style={{
//         color: "white",
//         maxWidth: "100%",
//         maxHeight: "100%",
//         fontFamily: "'Changa', sans-serif",
//       }}
//     >
//       <h3>لوحة تحكم المشرف - الإحصائيات</h3>

//       <Box
//         sx={{
//           display: "flex",
//           justifyContent: "space-around",
//           flexWrap: "wrap",
//           gap: "20px",
//           marginBottom: "40px",
//           marginTop: "6%",
//         }}
//       >
//         {Object.values(stats).map(({ label, value }, index) => (
//           <Paper
//             key={index}
//             sx={{
//               width: "200px",
//               height: "100px",
//               display: "flex",
//               flexDirection: "column",
//               justifyContent: "center",
//               alignItems: "center",
//               backgroundColor: "#333",
//               color: "white",
//               borderRadius: "10px",
//               padding: "10px",
//             }}
//           >
//             <Typography style={{ fontSize: "100%" }}>{label}</Typography>
//             <Typography variant="h5" style={{ fontWeight: "bold" }}>
//               {value}
//             </Typography>
//           </Paper>
//         ))}
//       </Box>
//       <hr style={{ borderTop: "1px solid #333" }} />
//       <Box
//         sx={{
//           width: "100%",
//           height: "55vh",
//           //  display: "flex",
//           //justifyContent: "center",
//           marginTop: "3%",
//           borderRadius: "10px",

//           //gap: 4,
//           //flexWrap: "wrap",
//         }}
//       ></Box>
//     </div>
//   );
// }

// export default Dashboard;
